<template>
  <div>
		<section-plan />
		<company-data is-japi/>
		<app-footer is-japi/>
	</div>  
</template>
<script>
import sectionPlan from '@/components/japi-sale/section-plan';
import companyData from '@/components/home-new/company-data';
import appFooter from '@/components/home-new/app-footer';

export default {
	name: 'page-japisales-planes',
	components: {
		sectionPlan,
		companyData,
		appFooter,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-japisale-planes.vue